<template>
    <div class="union-search">
        <form id="searchForm" @submit="subSearch($event)">
            <!-- <span class="sch-icon" @click="getFocus"><img src="../assets/images/btn_search2.png"></span> -->
            <input class="sch-ipt" autocomplete="off" autofocus="true" type="search" name="searchkey"
            v-model="keyword" :placeholder="placeholder" @click="getFocus" @keyup.enter="subSearch($event)">
            <!-- <span class="sch-handle" @click="subSearch"><img src="../assets/images/btn_search.png"></span> -->
            <span class="sch-icon" @click="subSearch($event)"><img src="../assets/images/btn_search2.png"></span>
        </form>
    </div>
</template>
<script>
    export default {
        props: {
            placeholder: {
                type: String,
                default: "搜索"
            }
        },
        data(){
            return {
                keyword: ""
            }
        },
        methods:{
            //提交搜索
            subSearch($event){
                $event.preventDefault();
                this.closeKeyboard();
                let keyWords = this.keyword.replace(/(^\s*)|(\s*$)/g, "");
                this.keyword = keyWords;
                this.$emit("subSearch",this.keyword);
            },
            //关闭软键盘
            closeKeyboard(){
                this.getBlur();
                document.activeElement.blur();
            },
            getFocus(){
                this.$el.querySelector(".sch-ipt").focus();
            },
            getBlur(){
                this.$el.querySelector(".sch-ipt").blur();
            },
        }
    }
</script>
<style>
    .union-search{
        width: 92%;
        height: 0.68rem;
        margin: 0.2rem auto 0.2rem;
        z-index: 9;
        font-size: 0.26rem;
    }
    .union-search #searchForm{
        width: 100%;
        height: 100%;
        overflow: hidden;
        background-color: #ffffff;
        border: 1px solid #b5b6b6;
        border-radius: 0.36rem;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        position: relative;
    }
    .union-search .sch-icon{
        flex: 0 0 auto;
        width: 0.4rem;
        padding: 0 0.2rem 0 0.16rem;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
    }
    .union-search .sch-ipt{
        flex: 1 1 auto;
        padding: 0 0.26rem;
        font-size: 0.3rem;
    }
    .union-search .sch-handle{
        flex: 0 0 auto;
        width: 0.5rem;
        padding: 0 0.1rem;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
    }
</style>



// WEBPACK FOOTER //
// src/shared/components/search.vue